import * as ChartConstants from "../constants/chat.constant";

const initialState = {
  message: {},
  messageList: [],
  messageLoading: false,
  friends: [],
  friendsLoading: false,
  usersInfoList: [],
  usersInfoListLoading: false,
  messageCount: 0,
  messageCountLoading: false,
  activeTab: {
    fullName: "",
    profileImage: "",
    connected: false,
    message: "",
    matricNumber: "",
    id: "",
  },
  privateUserChats: new Map(),
  activeTabMap: new Map(),
};

const setPrivateUserChats = (
  privateUserChats,
  messageList,
  matricNumber,
  activeTabMap
) => {
  activeTabMap.set(matricNumber, matricNumber);
  if (messageList.length > 0) {
    if (privateUserChats.has(matricNumber)) {
      console.log("has matric number...don't save...");
    } else {
      privateUserChats.set(matricNumber, messageList);
    }
  }
  return privateUserChats;
};

const updateChatList = (privateUserChats, message, matricNumber) => {
  if (privateUserChats.has(matricNumber)) {
    privateUserChats.get(matricNumber).push(message);
  } else {
    privateUserChats.set(matricNumber, [message]);
  }
  return privateUserChats;
};

const modifyList = (currentList, data) => {
  currentList.push(data);
  return currentList;
};

const chatReducer = (state = initialState, action) => {
  const prevPrivateUserChats = state.privateUserChats;
  switch (action.type) {
    case ChartConstants.FETCH_MESSAGE_REQUEST:
      return { ...state, messageLoading: true };
    case ChartConstants.FETCH_MESSAGE_SUCCESS:
      const message = action.payload;
      const senderMatricNumber = action.payload.senderMatricNumber;
      return {
        ...state,
        messageLoading: false,
        privateUserChats: updateChatList(
          prevPrivateUserChats,
          message,
          senderMatricNumber
        ),
      };
    case ChartConstants.FETCH_MESSAGE_REQUEST:
      return { ...state, messageLoading: false };

    case ChartConstants.FETCH_PRIVATE_MESSAGE_REQUEST:
      return { ...state, messageLoading: true };
    case ChartConstants.FETCH_PRIVATE_MESSAGE_SUCCESS:
      const matricNumber = action.payload.matricNumber;
      const messageList = action.payload.data;
      const activeTabMap = state.activeTabMap;
      return {
        ...state,
        messageLoading: false,
        messageList: messageList,
        privateUserChats: setPrivateUserChats(
          prevPrivateUserChats,
          messageList,
          matricNumber,
          activeTabMap
        ),
      };
    case ChartConstants.FETCH_PRIVATE_MESSAGE_ERROR:
      return {
        ...state,
        messageLoading: false,
      };

    case ChartConstants.FETCH_USER_FRIENDS_REQUEST:
      return { ...state, friendsLoading: true };
    case ChartConstants.FETCH_USER_FRIENDS_SUCCESS:
      return {
        ...state,
        friends: action.payload.data,
        friendsLoading: false,
      };
    case ChartConstants.FETCH_USER_FRIENDS_ERROR:
      return {
        ...state,
        friendsLoading: false,
      };

    case ChartConstants.FETCH_STUDENTS_BY_MATRIC_REQUEST:
      return { ...state, usersInfoListLoading: true };
    case ChartConstants.FETCH_STUDENTS_BY_MATRIC_SUCCESS:
      return {
        ...state,
        usersInfoList: action.payload,
        usersInfoListLoading: false,
      };
    case ChartConstants.FETCH_STUDENTS_BY_MATRIC_ERROR:
      return {
        ...state,
        usersInfoListLoading: false,
      };
    case ChartConstants.ADD_USER_FRIEND_REQUEST:
      return { ...state, friendsLoading: true };
    case ChartConstants.ADD_USER_FRIEND_SUCCESS:
      const friendsList = [...state.friends];
      const updatedList = modifyList(friendsList, action.payload);
      return {
        ...state,
        friends: updatedList,
        friendsLoading: false,
      };
    case ChartConstants.ADD_USER_FRIEND_ERROR:
      return { ...state, friendsLoading: false };
    case ChartConstants.MESSAGE_COUNT_REQUEST:
      return { ...state, messageCountLoading: true };
    case ChartConstants.MESSAGE_COUNT_SUCCESS:
      return {
        ...state,
        messageCountLoading: false,
        messageCount: action.payload,
      };
    case ChartConstants.MESSAGE_COUNT_ERROR:
      return { ...state, messageCountLoading: false };

    case ChartConstants.UPDATE_ACTIVE_TAB:
      return {
        ...state,
        activeTab: action.payload,
      };

    default:
      return state;
  }
};

export default chatReducer;
